var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChartStackedArea } from "../svg-elements/module";
import { parseHistoryForStackedArea } from "../d3-services/data-with-history.functions";
import * as d3 from "d3";
import HtmlLegendDots from "../html-elements/html-legend-dots";
import { GraphControllerV2 } from "./graph-v2";
import { flattenColumn } from "../d3-services/_helpers";
import { breakpoints } from "../_styleguide/_breakpoints";
var StackedAreaMms = /** @class */ (function (_super) {
    __extends(StackedAreaMms, _super);
    function StackedAreaMms(main, data, element, mapping, segment) {
        var _this = _super.call(this, main, data, element, mapping, segment) || this;
        _this.main = main;
        _this.data = data;
        _this.element = element;
        _this.mapping = mapping;
        _this.segment = segment;
        _this.pre();
        return _this;
    }
    StackedAreaMms.prototype.pre = function () {
        this._addScale('x', 'time', 'horizontal', '_date');
        this._addScale('y', 'linear', 'vertical', flattenColumn(this.firstMapping['column']));
        this._addAxis("x", "x", "bottom");
        this._addAxis("y", "y", "left");
        this._addMargin(0, 30, 0, 0);
        this._addPadding(20, 0, 40, 0);
    };
    StackedAreaMms.prototype.init = function () {
        _super.prototype._init.call(this);
        var svgId = "svg-wrapper-" + this.mapping.slug;
        var container = document.createElement('section');
        container.style.display = 'flex';
        container.style.flexDirection = window.innerWidth < breakpoints.sm ? 'column' : 'column';
        container.style.marginBottom = '3rem';
        container.style.height = "280px";
        container.style.width = "100%";
        container.id = svgId;
        this.element.appendChild(container);
        _super.prototype._svg.call(this, container);
        this.config.paddingInner = 0;
        this.config.paddingOuter = 0;
        this.chartStackedArea = new ChartStackedArea(this);
        this.legend = new HtmlLegendDots(this);
        this.update(this.data, "all", false);
    };
    StackedAreaMms.prototype.prepareData = function (data) {
        var history = parseHistoryForStackedArea(this.mapping, data);
        history = history.slice(1, history.length);
        this.keys = Object.keys(history[0]).filter(function (key) {
            return ['_date', 'gemeente', 'label', 'colour'].indexOf(key) < 0;
        });
        this.stack = d3.stack()
            .keys(this.keys);
        return {
            "history": history,
            "latest": null,
            "slice": history,
            "stacked": this.stack(history) // add keys and labels here ? 
        };
    };
    StackedAreaMms.prototype.draw = function (data) {
        var _this = this;
        this.xScale = this.scales.x.set(data.slice.map(function (d) { return d[_this.parameters.x]; }));
        this.chartStackedArea.draw(data.stacked);
    };
    StackedAreaMms.prototype.redraw = function (data) {
        this.yScale = this.scales.y.set(Object.values(data.stacked[data.stacked.length - 1]).map(function (d) { return d[1]; }));
        _super.prototype.redraw.call(this, data);
        this.chartStackedArea.redraw();
    };
    StackedAreaMms.prototype.update = function (data, segment, update) {
        _super.prototype._update.call(this, data, segment, update);
    };
    return StackedAreaMms;
}(GraphControllerV2));
export default StackedAreaMms;
